module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "name": "hres81x"
    }
  }, [(!_vm.flgLoginSuccess) ? _c('div', {
    staticClass: "hres81x-login"
  }, [_c('div', {
    staticClass: "form-horizontal"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    class: {
      'input-error': _vm.errors.has('password')
    },
    attrs: {
      "type": "password",
      "id": "payslipPassword",
      "placeholder": "Password",
      "data-vv-value-path": "password",
      "name": "password",
      "has-error": _vm.errors.has('password')
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.hres81xLogin()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('password')),
      expression: "errors.has('password')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('password')))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('button', {
    staticClass: "btn btn-default bg-color-skin",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.hres81xLogin()
      }
    }
  }, [_vm._v("Login")])])])])]) : _vm._e(), _vm._v(" "), (_vm.flgLoginSuccess) ? _c('search-box-index', {
    attrs: {
      "receivedStore": _vm.receivedHres81xIndex,
      "searchBoxAlias": "hres81x",
      "currentUser": _vm.dash.currentUser,
      "nowLang": _vm.dash.nowLang,
      "labels": _vm.labels[_vm.dash.nowLang],
      "labelsHres81x": _vm.dash.hres81x[_vm.dash.nowLang],
      "msgError": _vm.index.msg_error,
      "data": _vm.index,
      "postHres81xPrint": _vm.postHres81xPrint,
      "lastNumperiod": _vm.lastNumperiod,
      "numperiod": _vm.numperiod,
      "receivedHres81xNumperiod": _vm.receivedHres81xNumperiod,
      "flgProcess": _vm.flgProcess
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-lock"
  })]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("Please login to view your Payslip.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e6ec56a4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hres81x/component.vue
// module id = 4004
// module chunks = 1